/* Today (13-09): the page frame. The briefing, queue and rail styles are in
   components/today/today.module.css (ported from design/mock-13). */

/* The briefing's wash is 100vw wide; clip the scrollbar's width of it so the page never scrolls
   sideways (the mock clips html/body). */
.frame {
  overflow-x: clip;
}

.page {
  max-width: var(--shell-max);
  margin: 0 auto;
  padding: 0 var(--shell-gutter) 120px;
}

/* the mock's .today-grid: the queue, then a 290 px rail */
.grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 290px;
  gap: 40px;
  align-items: start;
}

@media (max-width: 960px) {
  .grid {
    grid-template-columns: 1fr;
  }
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
